<template>
	<link-dropdown
		class="link-auto-table-filter-store"
		width="180px"
		:height="192"
		align="start"
		direction="bottom"
		v-model="predefinedShow"
		style="margin-left: 16px;"
		:hideOnClickItem="false">
		<div slot="reference" class="link-auto-table-filter-store-button" @click="pl_clickReference">
			<link-icon icon="link-icon-star"/>
			<link-icon :icon="predefinedShow?'icon-triangle-up1':'icon-triangle-down1'"/>
		</div>
		<div slot="popover" class="link-auto-table-filter-store-list">
			<link-dropdown-item label="无" v-if="!option.storeFilter.data || option.storeFilter.data.length===0"/>
			<link-dropdown-item align="flex-start"
								v-for="(item,index) in option.storeFilter.data"
								:key="index"
								@click="pl_clickStoreFilterItem(item)"
								:label="item.filterDescribe"/>
			<link-dropdown-item align="flex-start" icon="icon-plus" label="创建快速筛选" @click="predefinedShow=false;option.showFilter()" class="link-auto-table-filter-store-create-button"/>
		</div>
	</link-dropdown>
</template>

<script>
export default {
	name: "link-auto-table-filter-store",
	props: {
		option: {},
	},
	data() {
		return {
			predefinedShow: false,
		}
	},
	methods: {
		/**
		 * 处理点击按钮事件
		 * @author  韦胜健
		 * @date    2019/3/29 18:36
		 */
		async pl_clickReference() {
			if (!this.option.storeFilter.initialized) {
				await this.pl_initStoreFilter()
			}
		},
		/**
		 * 初始化收藏的筛选数据
		 * @author  韦胜健
		 * @date    2019/3/29 18:37
		 */
		async pl_initStoreFilter() {
			const storeFilter = this.option.storeFilter
			if (!!storeFilter.initialized) return
			const param = {
				order: 'asc',
				sort: 'created',
				interfacePath: this.option._queryByExamplePage,
				oauth: 'ALL',
				// pagePath: location.pathname,
              	pagePath: this.option.context.pageTabData ? this.option.context.pageTabData.path : location.href,
			}
			const data = await this.$http.post(`${LinkVue.prefixUrl}/combinationQuery/queryAll`, param, true)
			storeFilter.initialized = true
			if (!!data.rows) data.rows.forEach(item => {
				item.filterResults = JSON.parse(item.resultsRaw)
				const filterValue = JSON.parse(item.filterValue)
				if (Array.isArray(filterValue)) {
					item.filtersRaw = filterValue
					item.filterOperator = ''
				} else {
					const {filtersRaw, filterOperator} = filterValue
					item.filtersRaw = filtersRaw
					item.filterOperator = filterOperator
				}
				item.filterResults.forEach(i => {
					if (i.type === 'date' && i.condition === 'between') i.multival = true
				})
			})
			this.option.storeFilter.data = (data.rows || []).reverse().concat(await this.getDefaultOption())
		},
		/**
		 * 处理点击收藏的筛选选项动作
		 * @author  韦胜健
		 * @date    2019/3/29 18:37
		 */
		async pl_clickStoreFilterItem(item) {
			this.option.combineFilter.filterResults = this.$lv.$utils.deepCopy(item.filterResults)
			this.option.combineFilter.filtersRaw = this.$lv.$utils.deepCopy(item.filtersRaw)
			this.option.combineFilter.filterOperator = this.$lv.$utils.deepCopy(item.filterOperator)
			this.predefinedShow = false
			await this.option.reload()
		},
		/**
		 * 获取默认的筛选选项
		 * @author  韦胜健
		 * @date    2019/3/29 18:37
		 */
		async getDefaultOption() {
			const defaultOption = []
			/*最近创建时间*/
			const recentlyCreatedNum = await this.$lv.$property.getProperty('recentlyCreatedNum')
			let {start, end} = this.getDurationDate(recentlyCreatedNum - 0)
			defaultOption.push({
				filterDescribe: `最近${recentlyCreatedNum}天创建的数据`,
				filterResults: [{multival: true, multi: false, type: "date", condition: "between", field: "created", value: "", values: [start, end]}],
				filtersRaw: [
					{id: "created", property: "created", operator: ">=", value: `${start} 00:00:00`, type: "date"},
					{id: "created1", property: "created", operator: "<=", value: `${end} 23:59:59`, type: "date"}
				],
			})
			/*最近更新时间*/
			const recentlyUpdatedNum = await this.$lv.$property.getProperty('recentlyUpdatedNum')
			let {start: start1, end: end1} = this.getDurationDate(recentlyUpdatedNum - 0)
			defaultOption.push({
				filterDescribe: `最近${recentlyUpdatedNum}天更新的数据`,
				filterResults: [{multival: true, multi: false, type: "date", condition: "between", field: "lastUpdated", value: "", values: [start1, end1]}],
				filtersRaw: [
					{id: "lastUpdated", property: "lastUpdated", operator: ">=", value: `${start1} 00:00:00`, type: "date"},
					{id: "lastUpdated1", property: "lastUpdated", operator: "<=", value: `${end1} 23:59:59`, type: "date"}
				],
			})
			return defaultOption
		},
		/**
		 * 获取当天以及前几天字符串
		 * @author  韦胜健
		 * @date    2019/3/29 18:37
		 */
		getDurationDate(day) {
			const today = new Date()
			const end = this.$lv.$utils.dateFormat(today, 'YYYY-MM-DD')
			today.setTime(today.getTime() - 24 * 60 * 60 * 1000 * (day - 0))
			const start = this.$lv.$utils.dateFormat(today, 'YYYY-MM-DD')
			return {start, end}
		},
	}
}
</script>

<style lang="scss">
@include themeify {
	.link-auto-table-filter-store-button {
		height: 28px;
		text-align: center;
		padding-left: 8px;
		padding-right: 4px;
		border: #DCE1F3 1px solid;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		color: #8798AD;
		cursor: pointer;
		background-color: #F4F6FC;

		&:hover {
			background-color: #F4F6FC;
		}

		&:active {
			background-color: #e4e6ec;
		}

		&.link-auto-table-filter-store-button-active {
			background-color: $color-primary;
			border-color: $color-primary;
			color: white;
		}
	}
	.link-auto-table-filter-store-create-button {
		color: $color-primary;
	}
}
</style>
